<template >
  <div>
    <div>
      <div class="formPosition">
        <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading"
          v-show="isLoading"></v-progress-linear>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table :headers="headers" :items="estudantes" :search="searchInDb" sort-by="data_" class="elevation-3">
          <template v-slot:top>
            <v-toolbar flat color="white">

              <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

              <v-divider class="mx-8" inset vertical></v-divider>
              <v-toolbar-title>Estudante <span v-if="idclasse === 1"> 10ª classe</span>
                <span v-if="idclasse === 2"> 11ª classe</span><span v-if="idclasse === 3"> 12ª classe</span>
                <span v-if="idclasse === 4"> 13ª classe</span>
              </v-toolbar-title>

              <v-divider class="mx-8" inset vertical></v-divider>


              <div class="searchPageListContainer">
                <v-text-field class="searchPageList" v-model="searchInDb" append-icon="search" label="Pesquisar Estudante"
                  rounded single-line hide-details></v-text-field>
                <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
                  <v-icon>cached</v-icon>
                </v-btn>
              </div>
              <v-select style="margin-top:25px;margin-left:50px;" :items="anolectivos" v-model="anolectivoSelected"
                @change="PesquisarEstudantes()" item-value="descricao" item-text="novadescricao"
                label="Selecione o anolectivo"></v-select>


              <!-- ============================================================================ -->
              <v-row justify="center">
                <v-dialog v-model="dialog_delete" persistent max-width="490">
                  <v-card>
                    <v-overlay :value="overlay">
                      <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                    <v-card-title class="headline">Eliminar estudante</v-card-title>
                    <v-card-text>Tem a certeza que pretente continuar com operação ? </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="dialog_delete = false">Cancelar</v-btn>
                      <v-btn color="green darken-1" text @click="Delete()">Continuar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              <!--=================================================================================-->

              <!-- ============================================================================ -->
              <v-row justify="center">
                <v-dialog v-model="dialog_confirmar" max-width="490">
                  <v-card>
                    <v-card-title class="headline">Mudança de curso</v-card-title>
                    <v-card-text>Tem a certeza que pretente continuar com operação ? </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="dialog_confirmar = false">Cancelar</v-btn>
                      <v-btn color="green darken-1" text @click="saveCurso()">Continuar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              <!--==============================MUDANÇA DE CURSO===================================================-->

              <v-dialog v-model="dialog_curso" max-width="800px">

                <v-card>

                  <template>

                    <v-toolbar color="grey lighten-2">

                      <v-row>
                        <v-col cols="12" md="4">

                          <v-btn text @click="closeCurso"><v-icon large color="primary">clear</v-icon></v-btn>

                        </v-col>

                        <v-col cols="12" md="7"> <!--  form titlte section   {{ formTitle }}-->
                          Mudança de Curso <span v-if="idclasse === 1"> 10ª classe</span>
                          <v-progress-circular v-if="progresso" indeterminate color="green"></v-progress-circular>
                        </v-col>

                        <v-col cols="12" md="1">
                          <v-btn :disabled="!valid" color="primary" text @click="showDialog"><v-icon large
                              color="primary">send</v-icon></v-btn>
                        </v-col>

                      </v-row>

                    </v-toolbar>

                  </template>

                  <v-form ref="form" v-model="valid" lazy-validation>

                    <v-card-text>

                      <v-container>

                        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                          {{ $store.state.textMessage }}</div>

                        <v-row>
                          <v-col cols="12" md="8">
                            <v-text-field :rules="ruleTextRequired" v-model="editedItem.nome" label="Nome"
                              :disabled="true"></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4">
                            <v-text-field required v-model="editedItem.bi" :label="descricao" v-mask="mascara"
                              :disabled="true"></v-text-field>

                          </v-col>

                        </v-row>
                        <v-row>

                          <v-col cols="12" md="6">
                            <v-combobox v-if="true" v-model="editedItem.idCurso" :rules="ruleRequired"
                              item-value="idCurso" item-text="descricao" @change="loadTurmaComb" @click="loadTurmaComb"
                              :items="cursos" chips label="Curso"></v-combobox>

                          </v-col>

                          <v-col cols="12" md="6">

                            <v-combobox id="turma" v-if="true" v-model="editedItem.turma" :rules="ruleRequired"
                              item-value="pkTurma" item-text="turmadescricao" :items="turmasFiltered" chips
                              label="Turma"></v-combobox>
                          </v-col>

                        </v-row>

                      </v-container>
                    </v-card-text>

                  </v-form>

                </v-card>
              </v-dialog>

              <!-- =================================================================================== -->
              <v-dialog v-model="dialog" max-width="800px">

                <v-card>

                  <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <template>

                    <v-toolbar color="grey lighten-2">

                      <v-row>
                        <v-col cols="12" md="4">

                          <v-btn text @click="close"><v-icon large color="primary">clear</v-icon></v-btn>

                        </v-col>

                        <v-col cols="12" md="7"> <!--  form titlte section   {{ formTitle }}-->
                          Actualizar <span v-if="idclasse === 1"> 10ª classe</span>
                          <span v-if="idclasse === 2"> 11ª classe</span><span v-if="idclasse === 3"> 12ª classe</span>
                          <span v-if="idclasse === 4"> 13ª classe</span>
                        </v-col>

                        <v-col cols="12" md="1">
                          <v-btn :disabled="!valid" color="primary" text @click="save"><v-icon large
                              color="primary">send</v-icon></v-btn>
                        </v-col>

                      </v-row>

                    </v-toolbar>

                  </template>

                  <v-form ref="form" v-model="valid" lazy-validation>

                    <v-card-text>

                      <v-container>

                        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                          {{ $store.state.textMessage }}</div>

                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field :rules="ruleTextRequired" v-model="editedItem.nome" label="Nome"></v-text-field>
                          </v-col>

                          <v-col cols="12" md="3">
                            <v-text-field required :rules="ruleBI" v-model="editedItem.bi" :label="descricao"
                              v-mask="mascara"></v-text-field>

                          </v-col>
                          <v-col cols="12" md="2">
                            <v-switch @change="outroDoc()"></v-switch>
                          </v-col>

                          <v-col cols="12" md="3">

                            <template>
                              <v-menu ref="menubi" v-model="menubi" :close-on-content-click="false"
                                transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="editedItem.dataemissaobi"
                                    :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de emissâo do BI"
                                    prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker ref="picker" max="2025-12-31" min="1950-01-01" v-model="datebi"
                                  @change="saveDatebi"></v-date-picker>
                              </v-menu>
                            </template>
                          </v-col>

                          <v-col cols="12" md="4">
                            <v-text-field :rules="ruleTextRequired" v-if="false" v-model="editedItem.pkPessoa"
                              label="chave primaria auto increemente"></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>

                          <v-col cols="12" md="4">

                            <v-text-field :rules="ruleTextRequired" v-model="editedItem.nomedopai"
                              label="Filho de:"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field :rules="ruleTextRequired" v-model="editedItem.nomedamae"
                              label=" e de:"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <template>

                              <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="editedItem.datanascimento"
                                    :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de nascimento"
                                    prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker ref="picker" v-model="date" max="2006-12-31" min="1950-01-01"
                                  @change="saveDate"></v-date-picker>
                              </v-menu>
                            </template>

                          </v-col>

                        </v-row>

                        <v-row>
                          <v-col cols="12" md="4">
                            <v-combobox :rules="ruleRequired" v-model="proviSelectedForComb" :items="provincias"
                              item-value="idProvicia" item-text="descricao" @change="loadMunicipioComb"
                              @click="loadMunicipioComb" chips label="Natural de:"></v-combobox>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-combobox :rules="ruleRequired" v-model="municSelectedForComb" :items="municipiosFiltered"
                              item-value="idMunicipio" item-text="descricao" chips label="Municipio"></v-combobox>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-combobox v-model="editedItem.sexo" :rules="ruleRequired" item-value="idSexo"
                              item-text="descricao" :items="dropdowSexo" chips label="Sexo"></v-combobox>
                          </v-col>

                        </v-row>
                        <v-row>

                          <v-col cols="12" md="4">
                            <v-text-field v-model="editedItem.telefone" label="Telefone">
                            </v-text-field>
                          </v-col>

                        </v-row>

                      </v-container>
                    </v-card-text>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <!-- <template v-slot:item.action="{ item }">
            <v-menu bottom origin="center center" transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-btn fab dark color="teal" style="color:white" v-on="on">
                  <v-icon>menu</v-icon>
                </v-btn>
              </template> -->

              <!-- <v-list v-if="role === 'ROLE_PED'"> -->
                <!-- <v-list-item @click="editItem(item)"><v-icon color="green">edit</v-icon>Editar dados</v-list-item> -->
                <!-- <v-list-item @click="MudarCurso(item)" v-if="role === 'ROLE_PED'"><v-icon -->
                    <!-- color="green">swap_horiz</v-icon>Mudança de Curso</v-list-item> -->
                <!-- <v-list-item @click="showEliminar(item)"><v-icon color="red">delete</v-icon>Eliminar</v-list-item> -->
              <!-- </v-list> -->
            <!-- </v-menu> -->

            <!--<v-img  style="color:green" src="../assets/boletim.jpg" width="80px"  class="mr-2" @click="editItem(item)"></v-img>-->
          <!-- </template> -->
          <template v-slot:no-data>
            <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
            Clica em + para adicionar novo estudante
          </template>
        </v-data-table>

      </div>
    </div>
  </div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
import Swal from 'sweetalert2'
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    classeSelecionada: { id: 1, descricao: '10ª' },
    Listaranoslectivo: [],
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    datebi: null,
    date: null,
    descricao: 'Nº do Bi',
    dialog_confirmar: false,
    dialog_curso: false,
    dialog_delete: false,
    valid: true,
    menu: false,
    menubi: false,
    habilitaBi: false,
    showLink: false,
    overlay: false,
    cursosFiltrados: null,
    startDate: null,
    cursos: [],
    anolectivos: [],
    anolectivoSelected: ls.get('anolectivo'),
    isLoading: true,
    turmasAll: [],
    nomeClasse: '',
    mascara: '#########-AA-###',
    turmasAllAno: [],
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    progresso: false,
    searchInDb: '',
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Bilhete de Identidade / Outro documento', value: 'bi' },
      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Turma', value: 'turma' },
      { text: 'Data de Cadastro/Moficação', value: 'data_' },
      // { text: 'Editar', value: 'action', sortable: false }
    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMAtricula: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      resultado: '',
      fkTurma: '',
      pkInscricao_na_turma: '',
      pkTurma: 0,
      idano_academico: 0,
      anoLectivo: ''
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null,
      anoLectivo: '',
      classes: [
        { id: 1, descricao: '10ª' },
        { id: 2, descricao: '11ª' },
        { id: 3, descricao: '12ª' },
        { id: 4, descricao: '13ª' },
      ]
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse() {
      return this.$store.state.idclasse
    },
    computeddatanascimento() {
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns() {
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage() {
      return this.$store.state.textMessage
    },
    classMessage() {
      return this.$store.state.classMessage
    },
    hasMessage() {
      return this.$store.state.hasMessage
    },
    role() {
      return ls.get('role')
    }

  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes() {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    // check if classe has been selected otherwise send back to painel to select
    if (!this.$store.state.idclasse) { this.$router.push('/painelclasses-search') }

    // this.CarregActividades()
    this.initializeAnosLectivo()
    this.initialize()
    this.initializeCursos()
    this.initializeturmasAll(this.idclasse)
    this.initializeMunicipiosAll()
    this.initializeProvincias()
  },

  methods: {
    async initialize(searchInDb) {
      try {
        this.overlay = true
        if (!searchInDb) {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"all", "anolectivo":"' + this.anolectivoSelected + '"}'
        } else {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"' + searchInDb + '" , "anolectivo":"' + this.anolectivoSelected + '"}'
        }

        this.estudantes = await axios.get('/estudanteFindAll/' + payload).then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo

    async initializeAnosLectivo() {
      try {
        this.anolectivos = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento do ano lectivo!', 'error');
      }
    },


    // METHODO FOR VALIDATION
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc() {
      if (this.descricao === 'Outro Doc.') {
        this.outroDocmento = false
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
          [
            value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
          ]
      } else {
        this.outroDocmento = true
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
          [
            value => (value.length > 6) && (value.length <= 30 || 'Minimo de caracteres exigido( 16 )')
          ]
      }
    },

    loadTurmaComb(curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },
    loadMunicipioComb(provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll() {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    closeCurso() {
      this.dialog_curso = false
    },

    async initializeProvincias() {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades() {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    MudarCurso(item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_curso = true
    },

    async initializeCursos() {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll(idclasse) {
      try {
        this.overlay = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + idclasse)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem(item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    showEliminar(item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_delete = true
    },

    close() {
      this.dialog = false
      this.$refs.form.reset()
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    saveDate(date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      // this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.overlay = true
        const ls = require('local-storage')
        var params = {
          pkPessoa: this.editedItem.pkPessoa,
          idPEssoa: this.editedItem.bi,
          idMunicipio: this.municSelectedForComb.idMunicipio,
          idPerfil: 1,
          nome: this.editedItem.nome,
          morada: this.editedItem.morada,
          telefone: this.editedItem.telefone,
          autor: ls.get('idPessoa'),
          datanascimento: this.editedItem.datanascimento,
          data_: this.editedItem.data_,
          status_2: this.editedItem.status_2,
          email: this.editedItem.email,
          sexo: 'M',
          nomedopai: this.editedItem.nomedopai,
          nomedamae: this.editedItem.nomedamae,
          dataemissaobi: this.editedItem.dataemissaobi,
          bi: this.editedItem.bi,
          ResidenteEm: 1,
          instituicao: ls.get('i_id'),
          instituicaodescricao: this.editedItem.instituicaodescricao,
          curso: this.editedItem.curso,
          turma: this.editedItem.turma,
          anolectivo: ls.get('anolectivo'),
          idanolectivo: ls.get('idanolectivo'),
          idanoacademico: this.idclasse,
          matricula: this.editedItem.idMatricula,
          isIntegrado: ls.get('isintegrado')
        }

        try {
          let msg = await axios
            .post('/editarInformacoesEstudante', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 2000 })
            }
          } catch (error) { }
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) { }
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) { }

          if (this.editedIndex > -1) {
            //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.unshift(this.editedItem)
          }
          //  this.close();
          this.progresso = false
          this.initialize()
        } catch (error) {
          this.isLoading = false
          this.progresso = false
          this.text = error.message
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } finally {
          this.overlay = false
        }
        if (this.msg === 'Número de Bi ja existente');
        else {
          this.editedItem.nome = ''
          this.editedItem.nomedopai = ''
          this.editedItem.nomedamae = ''
          this.editedItem.datanascimento = ''
          this.editedItem.dataemissaobi = ''
          this.editedItem.bi = ''
          this.editedItem.sexo = ''
          this.editedItem.telefone = ''
          this.editedItem.municipio = ''
          this.editedItem.provincia = ''
          this.$refs.form.resetValidation()
          if (this.editedItem.pkPessoa) {
            this.editedItem.pkPessoa = null
            setTimeout(() => {
              this.close()
            }, 1000)
          }
        }
      }
    },

    showDialog() {
      this.dialog_confirmar = true
    },

    async saveCurso() {
      if ((this.$refs.form.validate())) {
        this.progresso = true
        this.dialog_confirmar = false
        let corMensagem = 'msgError'
        let params =
        {
          idmatricula: this.editedItem.idMAtricula,
          idturma: this.editedItem.turma.idTurma,
          pkPessoa: this.editedItem.pkPessoa,
          idanolectivo: this.editedItem.turma.anoLectivo,
          pkTurma: this.editedItem.turma.pkTurma,
          idcurso: this.editedItem.turma.idCurso,
          bi: this.editedItem.bi,
          idanoacademico: this.editedItem.turma.idAno_Academico,
          resultado: (this.editedItem.resultado === 'Transita') ? 1 : 0,
          descricao_resultado: this.editedItem.resultado,
          fromtransferencia: 0,
          turma_antiga: this.editedItem.fkTurma,
          pkInscricao_na_turma: this.editedItem.pkInscricao_na_turma,
          pkTurmaActual: this.editedItem.fkTurma,
          idanoAcademicoActual: this.editedItem.idano_academico,
          anolectivo: this.editedItem.anoLectivo
        }

        try {
          // this.isLoading = true
          let msg = await axios
            .post('/MudarCursoInsertOrUpdate', params)
            .then(res => res.data)
          this.progresso = false
          if (!msg.length) {
            this.text = 'Mudança de curso efectuada com sucesso'
            corMensagem = 'msgSucess'
          } else {
            if (msg[0].classe !== undefined || msg[0].classe !== null) {
              this.retornaClasse(msg[0])
            } else {
              this.text = 'Ocorreu um erro ao tentar efectuar a mudança de curso'
              corMensagem = 'msgError'
            }
          }
          this.dialog_curso = false
          // this.Limpar(msg)
          this.progresso = false

          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
        } catch (error) {
          this.progresso = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    retornaClasse(idClasse) {
      if (idClasse[0].classe === 1) { this.nomeClasse = '10ª Classe' }
      if (idClasse[0].classe === 2) { this.nomeClasse = '11ª Classe' }
      if (idClasse[0].classe === 3) { this.nomeClasse = '12ª Classe' }
      if (idClasse[0].classe === 4) { this.nomeClasse = '13ª Classe' }

      this.initializeturmasAllAnolectivo(idClasse[0].anolectivo, idClasse[0].classe)
      this.text = 'Antes de prosseguir efectuar primeiro a mudança na ' + this.nomeClasse
      this.showLink = true
      setTimeout(() => {
        this.showLink = false
      }, 10000)
    },

    async Delete() {
      let params =
      {
        pkLixeira: 0,
        tabela_from: 'Inscrição na turma',
        descricao: 'Eliminou o registro do estudante :' + this.editedItem.nome + ' Bilhete: ' + this.editedItem.bi + ' da turma : ' + this.editedItem.turma,
        id_from: this.editedItem.pkInscricao_na_turma,
        matricula: this.editedItem.idMatricula,
        status: 1
      }
      this.overlay = true

      try {
        let msg = await axios
          .post('/LixeiraInsertOrUpdate', params)
          .then(res => res.data)
        try {
          if (!msg.length) {
            this.text = 'Estudante eliminado com sucesso!'
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 2000 })
            this.estudantes.splice(this.editedIndex, 1)
            this.overlay = false
          }
        } catch (error) { }
        try {
          this.overlay = false
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } catch (error) { }
      } catch (error) {
        this.text = error.message
        this.overlay = false
      } finally {
        this.dialog_delete = false
        this.overlay = false
      }
    },
    async BuscarRegistroAluno() {
      this.overlay = true
      try {
        let items = await axios
          .get('/PesquisaLocal/' + this.editedItem.idMAtricula)
          .then(res => res.data)
        if (items.length) {
          let result = items.filter(p => p.classe === this.nomeClasse)
          if (result.length) {
            this.editedItem = Object.assign({}, result[0])
            this.overlay = false
            this.dialog_curso = true
          }
        }
        this.overlay = false
      } catch (error) {
        this.isLoading = false
        this.overlay = false

        this.text = error
      }
    },
    async initializeturmasAllAnolectivo(anolectivo, classe) {
      try {
        this.turmasAll = await axios
          .get('/turmaFindAllAno/' + anolectivo)
          .then(res => res.data)
        this.turmasAll = this.turmasAll.filter(t => parseInt(t.idAno_Academico) === parseInt(classe))
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }
  }
}
</script>
<style scoped>
.bg {
  color: green;
  background: red
}

.titlePageListar {
  text-align: center;
}

.searchPageListContainer {
  width: 30%;
  margin: 10px auto 0;
  display: flex;
}

.searchPageList {
  border: 1px solid #434343;
  border-radius: 30px;
}
</style>
